import { Toaster as Sonner, type ToasterProps } from "sonner";

/** Themed to our tokens — never the stock sonner palette. */
export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast bg-panel-elevated text-text border-line shadow-lg font-sans text-sm",
          description: "text-muted",
          actionButton: "bg-accent text-accent-contrast",
          cancelButton: "bg-panel text-muted",
          error: "border-status-cancelled",
          success: "border-accent",
        },
      }}
      {...props}
    />
  );
}
